import React from "react";
import { useQuery } from "@apollo/react-hooks";

import Stats from "./Stats";
import RoyaltiesNoActivity from "./RoyaltiesNoActivity";
import LoadingSpinner from "core/LoadingSpinner";
import Heading from "./Heading";
import MonthlyReport from "frontend/components/creator-dashboard/photos/monthly-report";

import { GET_LIFETIME_PHOTO_ROYALTIES_TOTALS } from "./queries";
import { userHasPhotoActivity } from "./helpers";

const Royalties = () => {
    const { data, loading } = useQuery(GET_LIFETIME_PHOTO_ROYALTIES_TOTALS);

    if (loading) return <LoadingSpinner />;

    const {
        photoRoyalties: { totals }
    } = data;

    if (!userHasPhotoActivity({ totals })) return <RoyaltiesNoActivity />;

    return (
        <>
            <Heading />
            <Stats totals={totals} />
            <MonthlyReport />
        </>
    );
};

export default Royalties;
